<template lang="pug">
  .empty-panel
    .flex-wrap
      .info-box
        .main-info Courses are your library of training modules that can be assigned to programmes.


        .check-list
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              p SCORM Compliant Hosting (standardised e-learning modules)
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              p Support for Powerpoint, PDF and docs
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              p Set programme dependencies so that courses are completed in order
            


        router-link(:to="{ name: 'itrain:courseCreate' }")
                .el-button.pink GET STARTED
      .img-box
        img(src='@/assets/images/emptystates/itrain-holder.png')

</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
